import { color } from "@mui/system";
import React from "react";

const ChannelDetail = () => {
    return (
        <div style={{color:'red'}}>ChannelDetail</div>
    );
}

export default ChannelDetail;